"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./LoadingDots.css");

var _styles = {
  "container": "LoadingDots__container___1eAqL"
};

const styles = _bind.default.bind(_styles);

const LoadingDots = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('container'), className);
  return _react.default.createElement("div", {
    className: composed_classname,
    "data-testid": dataTestId,
    ...props
  });
});
var _default = LoadingDots;
exports.default = _default;